import { useState, useCallback } from "react";
import { pdf } from "@react-pdf/renderer";
import JSZip from "jszip";
import ActaPDF from "./Actapdf";

/**
 * useDescargaActasGeneradas
 * Para participantes con estado SIN_DOCUMENTO:
 * genera el PDF con react-pdf y empaqueta todo en actas_generadas.zip
 */
const useDescargaActasGeneradas = () => {
  const [descargando, setDescargando] = useState(false);
  const [progreso, setProgreso]       = useState(0);
  const [total, setTotal]             = useState(0);
  const [actual, setActual]           = useState(0);
  const [nombreActual, setNombreActual] = useState("");

  const descargar = useCallback(async (participantes) => {
    if (!participantes?.length) return;

    setDescargando(true);
    setProgreso(0);
    setTotal(participantes.length);
    setActual(0);
    setNombreActual("");

    try {
      const zip     = new JSZip();
      const carpeta = zip.folder("actas");

      for (let i = 0; i < participantes.length; i++) {
        const p            = participantes[i];
        const nombreArchivo = `acta_${p.num_identificacion}.pdf`;

        setNombreActual(nombreArchivo);
        setActual(i + 1);

        // Genera el PDF en memoria con react-pdf
        const blob = await pdf(<ActaPDF participante={p} />).toBlob();
        carpeta.file(nombreArchivo, blob);

        setProgreso(Math.round(((i + 1) / participantes.length) * 100));
      }

      const zipBlob  = await zip.generateAsync({ type: "blob" });
      const url      = URL.createObjectURL(zipBlob);
      const link     = document.createElement("a");
      link.href      = url;
      link.download  = "actas_generadas.zip";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } finally {
      setDescargando(false);
      setProgreso(0);
      setActual(0);
      setTotal(0);
      setNombreActual("");
    }
  }, []);

  return { descargar, descargando, progreso, total, actual, nombreActual };
};

export default useDescargaActasGeneradas;